import { render, staticRenderFns } from "./win2022.vue?vue&type=template&id=981fdee4"
import script from "./win2022.vue?vue&type=script&lang=js"
export * from "./win2022.vue?vue&type=script&lang=js"
import style0 from "./win2022.vue?vue&type=style&index=0&id=981fdee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports